import React from 'react'
import { connect } from 'react-redux'

import LoginForm from './LoginForm'
import ForgotPasswordForm from './ForgotPasswordForm'

class AuthModal extends React.Component {
  render () {
    const { forgotPasswordView, forgotPasswordChange } = this.props

    return (
      <div>
        {forgotPasswordView
          ? <div>
            <ForgotPasswordForm forgotPasswordChange={forgotPasswordChange} />
          </div>
          : <div>

            <h3>Login</h3>

            <div className='text-align-right'>
              <a onClick={() => forgotPasswordChange(true)}>Forgot password?</a>
            </div>

            <LoginForm />
          </div>}

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps)(AuthModal)



// WEBPACK FOOTER //
// ./src/components/Auth/AuthModal.js